<template>
	<div v-loading.fullscreen.lock="fullscreenLoading">
		<section id="login_hero">
			<a href="https://www.yagish.jp/recruit/" target="_blank"><img
					src="/kr/resume/static/renew_img/bnr/login_top_banner_20220622.png" alt=""></a>
		</section>
		<div class="content-wrapper" style="padding:20px 0">
			Yagishの<router-link id="footer-link-terms" :to="{ name: 'termsPage' }"
				target="_blank">이용약관</router-link>,<router-link id="footer-link-terms" :to="{ name: 'policyPage' }"
				target="_blank">개인정보 취급</router-link>에 대하여<br>
			에 동의하신 후 로그인 해주세요.
		</div>
		<section id="login">
			<login-forms />
			<div class="content-wrapper">
				<register-forms />
			</div>
		</section>
		<section class="banner-contents" v-if="false">
			<ul class="banner-box">
				<li>
					<a href="https://bit.ly/39KLMRh" target="_blank"><img
							src="/kr/resume/static/renew_img/bnr/mypage_middle_banner_20211229_001.png"
							class="banner"></a>
				</li>
			</ul>
		</section>
		<div class="content-wrapper">
			<a href="https://lin.ee/0rfNtli" target="_blank"><img src="/kr/resume/static/renew_img/banner_line.png"
					class="banner-line sp"></a>
		</div>
		<section class="btn_top"><a class="btn_sub" href="/kr/resume/">메인으로</a></section>


		<section id="setting">
			<div class="content-wrapper">
				<input id="acd-title" class="acd-check" type="checkbox">
				<label class="acd-label" for="acd-title">설정<img
						src="/kr/resume/static/renew_img/icon_setting.svg"></label>
				<div class="acd-content">
					<div class="delite">
						<a href="#" @click.prevent="$router.push({ name: 'accountDelete' });"
							class="btn_green">데이터/계정삭제</a>
						<p>브라우저 데이터,서버 백업 데이터 ,등록 계정을 삭제할 수 있습니다.</p>
					</div>
				</div>
			</div>
		</section>


	</div>
</template>
<script>
import LoginForms from '@/components/IdPwLoginForms'
import RegisterForms from '@/components/RegisterForms'
import firebase from 'firebase/app'
export default {
	components: {
		'login-forms': LoginForms,
		'register-forms': RegisterForms
	},
	data: function () {
		return {
			fullscreenLoading: true
		}
	},
	created: function () {
		console.log('created')
		firebase.auth().onAuthStateChanged((user) => {
			if (user) {
				const urlParams = new URLSearchParams(window.location.search);
				var from_page = urlParams.get("frompage");
				if (from_page) {
					this.$router.push('/format/' + from_page + '/edit/output')
				} else {
					this.$router.push('/mypage')
				}
			}
			this.fullscreenLoading = false
		})
	},
	computed: {},
	mounted: function () {
	},
	methods: {},
	watch: {},
	mounted: function () { }
}
</script>
